import React from 'react';

import {ProteinAlignmentPanelState} from 'FileStates';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import ProteinAlignmentPanel from 'toolbar/aa-sequence/AaSequenceAlignmentPanel';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';

class ProteinAlignmentPanelView extends ReactPanelBaseView<ProteinAlignmentPanelState, AaSequence> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('proteinAlignment'),
        title: 'Alignments',
        // eslint-disable-next-line @typescript-eslint/unbound-method
        component: <ProteinAlignmentPanel proteinId={this.model.id} closePanel={this.closePanel} />,
      },
    ];
  }
}

export default ProteinAlignmentPanelView;
